import { medicalProviderDirectorySpecialtiesSections } from '../../../../../constants/medicalAttention';
import SpecialitySearch from '../Shared/SpecialitySearch';

const UrgentCare = () => (
  <SpecialitySearch section={medicalProviderDirectorySpecialtiesSections.URGENT_CARE} />
);
export default UrgentCare;
